import React from 'react';

const Footer = () => {
  return (
    <footer className="relative bg-gray-900 text-white py-12">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-50 z-0"></div>

      <div className="relative z-10 container mx-auto px-4">
        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About Us */}
          <div>
            <h2 className="text-xl font-bold mb-4">About Us</h2>
            <p className="text-sm leading-relaxed">
              Ceyone Foundations was set up by professionals from various fields to support Younger India in enhancing personal skills, career analysis, and assessment.
              <br /><br />
              Established on October 10, 2013, under the Indian Trust Act, Ceyone Foundations is registered under NITI Aayog.
            </p>
          </div>

          {/* Site Links */}
          <div>
            <h2 className="text-xl font-bold mb-4">Site Links</h2>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="hover:text-yellow-400 transition">Home</a></li>
              <li><a href="/about" className="hover:text-yellow-400 transition">About</a></li>
                       <li><a href="/services" className="hover:text-yellow-400 transition">Service</a></li>
                                <li><a href="/partners" className="hover:text-yellow-400 transition">Partner</a></li>
                                
                     <li><a href="/gallery" className="hover:text-yellow-400 transition">Gallery</a></li>
                            <li><a href="/contact" className="hover:text-yellow-400 transition">Contact Us</a></li>
          
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h2 className="text-xl font-bold mb-4">Contact Us</h2>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start">
                <span className="mr-2">📍</span>
                <span>
                  Registered Office & Corporate/Head Office:<br />
                  No 3-58/4, Sumohana Conclave, Pelatottu, Kalmanja Post & Village,<br />
                  Belthangady TQ, Dakshina Kannada 574228, Mangalore
                </span>
              </li>
              <li className="flex items-center">
                <span className="mr-2">🌐</span>
                <a href="https://www.ceyone.org" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition">
                  www.ceyone.org
                </a>
              </li>
              <li className="flex items-center">
                <span className="mr-2">✉️</span>
                <a href="mailto:hr.council@ceyone.org" className="hover:text-yellow-400 transition">
                  hr.council@ceyone.org
                </a>
              </li>
              <li className="flex items-center">
                <span className="mr-2">✉️</span>
                <a href="mailto:support@ceyone.org" className="hover:text-yellow-400 transition">
                  support@ceyone.org
                </a>
              </li>
              <li className="flex items-center">
                <span className="mr-2">📞</span>
                <a href="tel:+919448441531" className="hover:text-yellow-400 transition">
                  9448441531
                </a>
              </li>
            </ul>
          </div>

          {/* NGO Image */}
          <div>
            <h2 className="text-xl font-bold mb-4">Our Work</h2>
            <img src="/slide/13.jpg" alt="NGO work" className="w-full h-50 object-cover rounded-md shadow-md" />
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center text-sm border-t border-gray-700 pt-6 mt-6">
          <p>
            © {new Date().getFullYear()} All rights reserved | Made with <span className="text-red-500">❤️</span> by <a href="https://www.ceyone.org" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">Ceyone Foundation</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
